import { getOpxHostApp, O365_SHELL } from 'owa-config';

/** Track referrals to To Do app from My Day OPX hosted in Shell */
export function getToDoUtmSource(): string | undefined {
    return getOpxHostApp() === O365_SHELL ? 'MyDaySuiteHeader' : undefined;
}
